<script setup lang="ts">
defineProps<{
  snsRows: any[];
  snsLoading: boolean;
  snsColumns: ReadonlyArray<any>;
  snsCellPercent: (row: any, key: string) => number;
  formatPostCount: (n: number) => string;
}>();
</script>

<template>
  <div class="hd-panel hd-sns-panel">
    <div class="hd-panel-accent hd-panel-accent--pink-gray"></div>
    <div class="hd-panel-header hd-panel-header--sns">
      <div class="hd-panel-header-text">
        <h3 class="hd-panel-title">SNS別 流入元分析</h3>
        <p class="hd-panel-subtitle">各プラットフォームでの発信比率と主な拡散傾向</p>
      </div>
    </div>
    <div class="hd-table-scroll">
      <table v-if="!snsLoading && snsRows.length > 0" class="hd-sns-table">
        <thead>
          <tr>
            <th class="hd-s-col-keyword">キーワード</th>
            <th v-for="col in snsColumns" :key="col.key" class="hd-s-col-platform" :class="{ 'hd-s-col-count': !col.showBar }">
              <span v-if="col.showBar" class="hd-s-head-dot" :style="{ background: col.dot }"></span>
              <span class="hd-s-head-label">{{ col.label }}</span>
            </th>
            <th class="hd-s-col-fill"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in snsRows" :key="row.keyword">
            <td class="hd-s-cell-keyword"><span class="hd-keyword-dot" :style="{ background: row.dotColor }"></span><span class="hd-keyword-text">{{ row.keyword }}</span></td>
            <td v-for="col in snsColumns" :key="col.key" class="hd-s-cell-platform" :class="{ 'hd-s-cell-count': !col.showBar }">
              <span v-if="!col.showBar" class="hd-s-count">{{ formatPostCount(row.mentionCount) }}</span>
              <div v-else class="hd-s-cell-inner">
                <div class="hd-s-bar"><span class="hd-s-bar-fill" :style="{ width: snsCellPercent(row, col.key) + '%', background: col.color }"></span></div>
                <span class="hd-s-value" :style="{ color: col.color }">{{ snsCellPercent(row, col.key) }}%</span>
              </div>
            </td>
            <td class="hd-s-cell-fill"></td>
          </tr>
        </tbody>
      </table>
      <div v-else-if="snsLoading" class="hd-panel-empty">読み込み中...</div>
      <div v-else class="hd-panel-empty">データがありません</div>
    </div>
  </div>
</template>

<style scoped lang="less">
.hd-panel { border: 1px solid var(--border-color); border-radius: 6px; background: var(--bg-panel); overflow: hidden; margin-top: 16px; color: var(--text-primary); }
.hd-panel-accent { height: 3px; }
.hd-panel-accent--pink-gray { background: linear-gradient(90deg, #374151 0%, #e1306c 50%, #374151 100%); }
.hd-panel-header { padding: 12px 16px; border-bottom: 1px solid var(--border-color); }
.hd-panel-title { margin: 0; font-size: 12px; font-weight: 700; color: var(--text-primary); }
.hd-panel-subtitle { margin: 2px 0 0; font-size: 10px; color: var(--text-tertiary); }
.hd-table-scroll { width: 100%; overflow-x: auto; }
.hd-panel-empty { display: flex; align-items: center; justify-content: center; min-height: 120px; color: var(--text-tertiary); font-size: 13px; }
.hd-sns-table { width: 100%; border-collapse: collapse; table-layout: fixed; min-width: 640px; }
.hd-sns-table th, .hd-sns-table td { border-bottom: 1px solid var(--border-color); height: 35px; padding: 0 12px; }
.hd-sns-table thead th { background: var(--bg-body); font-size: 10px; color: var(--text-secondary); text-align: left; }
.hd-s-col-keyword { width: 141px; }
.hd-s-col-count { width: 88px; }
.hd-s-col-platform { width: 137px; }
.hd-keyword-dot { display: inline-block; width: 6px; height: 6px; border-radius: 50%; margin-right: 6px; }
.hd-keyword-text { font-size: 11px; font-weight: 600; color: var(--text-primary); }
.hd-s-head-dot { display: inline-block; width: 6px; height: 6px; border-radius: 50%; margin-right: 4px; }
.hd-s-cell-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  width: 121.45px;
  height: 15px;
}

.hd-s-bar {
  display: flex;
  align-items: flex-start;
  width: 66.08px;
  height: 5px;
  background: var(--border-color);
  border-radius: 9999px;
  overflow: hidden;
}

.hd-s-bar-fill {
  display: block;
  height: 5px;
  border-radius: 9999px;
}

.hd-s-value {
  width: 24px;
  height: 15px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  line-height: 15px;
  text-align: right;
  letter-spacing: 0.117188px;
  color: var(--text-primary);
}
.hd-s-count { font-size: 11px; font-weight: 600; color: var(--text-primary); }
</style>
